import { SurveyMetricField } from './types';

export const BAR_SIZE = 12;

export const labelBySurveyMetricField: Record<SurveyMetricField, string> = {
  // Uncomment when we have the response data
  //   responseRate: 'Response Rate',
  surveyViews: 'Survey Views',
};
